<template>
  <b-card>
    <h1>Type visits of {{ getCurrentMonth() }} - {{ total }}</h1>
    <vue-apex-charts :options="chartOptions" :series="series" type="pie" />
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { BCard } from 'bootstrap-vue'
import {
  chartFromPatientsByType,
  chartFromYearData,
} from '@/core/utils/patientsByTypeChart'

export default {
  components: {
    BCard,
    VueApexCharts,
  },
  props: {
    userData: {
      type: Object,
      default: () => ({}),
    },
    dataDashboard: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    // Conservado por compatibilidad con el padre; ya no se suma al gráfico
    memberships: {
      type: Object,
      required: false,
      default: () => ({ NP: 0, NC: 0 }),
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 400,
          width: '100%',
        },
        tooltip: {
          theme: 'custom',
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ['#3C231D'],
          },
          dropShadow: {
            enabled: false,
          },
        },
        labels: [],
        colors: [
          '#fbd5cc',
          '#ffc699',
          '#cadbbb',
          '#91b3a5',
          '#a6c6dd',
          '#ccdafd',
          '#c5dff0',
          '#f8e6b4',
          '#e8d5c4',
          '#d4a5a5',
          '#b8c5d6',
        ],
      },
      series: [],
      total: 0,
      isSmallScreen: window.innerWidth <= 768,
    }
  },
  watch: {
    dataDashboard: {
      immediate: true,
      handler() {
        this.updateChartData()
      },
    },
  },
  methods: {
    updateChartData() {
      const patientsByType =
        (this.dataDashboard && this.dataDashboard.patients_by_type) || []
      const opts = {
        shortLabels: this.isSmallScreen,
        lane: 'regular',
      }

      // patients_by_type ya incluye M/B e IV; no sumar memberships.NP/NC
      const chart =
        patientsByType.length > 0
          ? chartFromPatientsByType(patientsByType, opts)
          : chartFromYearData(
              (this.dataDashboard && this.dataDashboard.year_data) || [],
              opts
            )

      this.chartOptions = {
        ...this.chartOptions,
        labels: chart.labels,
      }
      this.series = chart.series
      this.total = chart.total
    },
    getCurrentMonth() {
      const months = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ]
      return months[new Date().getMonth()]
    },
  },
}
</script>

<style scoped>
h1 {
  font-size: 20px;
  font-weight: 600;
  color: #3c231d;
  margin-bottom: 20px;
}
</style>
